<ng-container>
    <p-confirmDialog #cd [styleClass]="dialog.title ? '' : 'sinHeader'" [style]="{width: '{{dialog.size}}vw'}" key="optionSelector" [closable]="false">
        <ng-template pTemplate="header">
            <div class="mt-2 ml-3" style="font-weight: 700; font-size: 16pt;">{{dialog.title}}</div>
        </ng-template>

        <ng-template pTemplate="message">
            <div class="dialog-content">
                <div class="instructions-section">
                    <p class="instructions-text">{{dialog.message}}</p>
                </div>
                <div class="options-section">
                    <div class="option-list">
                        <button *ngFor="let option of options; let index = index"
                                [class]="'boton boton--w200px ' + getOptionColorClass(option) + (index > 0 ? ' boton--separadoTop' : '')"
                                (click)="onOptionSelect(option.id)">
                            {{option.name || option.keyCode || ('Opción ' + option.id)}}
                        </button>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="footer">
            <button *ngIf="showCancelButton" class="boton boton--w120px boton--blanco"
                    (click)="onCancel()">
                {{'Cancelar' | translate}}
            </button>
        </ng-template>

    </p-confirmDialog>
</ng-container>
